import { isImmutable } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableServerError } from '@gonfalon/legacy-http-client/httpUtils';
import { type AlertProps, Alert } from '@launchpad-ui/components';

type StatusError = {
  [key: string]: string;
};

type Error = {
  message?: string;
  status?: string;
};

type ErrorAlertProps = AlertProps & {
  error?: ImmutableServerError | object | null;
};

const statusErrors: StatusError = {};

const unexpectedError = 'An unexpected error has occurred. Please try again later.';

const formatError = (error?: ImmutableServerError | object | null) => {
  if (!error) {
    return unexpectedError;
  }

  const err: Error = isImmutable(error) ? error.toJS() : error;

  if (err.message) {
    return err.message;
  } else if (err.status && statusErrors[err.status]) {
    return statusErrors[err as string];
  } else {
    return unexpectedError;
  }
};

export function ErrorAlert(props: ErrorAlertProps) {
  const { error, ...rest } = props;

  return (
    <Alert {...rest} status="error">
      {formatError(error)}
    </Alert>
  );
}
